// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";      // ✅ About Page
import Services from "./pages/Blog";    // ✅ If your Services component is actually in /pages/Blog
import Blog1 from "./pages/Blog1";
import Blog from "./components/Services";
import Contact from "./components/Contact"; // ✅ Contact Page
import Price from "./components/Price";
import Dmp from "./components/Dmp";
import Google from "./components/Google";
import Social from "./components/Social";
import Smm from "./components/Smm";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ✅ ScrollToTop Component (inside same file for simplicity)
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top smoothly whenever route changes
    window.scrollTo({
      top: 0,
      behavior: "smooth", // change to "auto" if you prefer instant scroll
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ This ensures page scrolls to top on route change */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog1" element={<Blog1 />} />
        <Route path="/price" element={<Price />} />
        <Route path="/dmp" element={<Dmp />} />
        <Route path="/google" element={<Google />} />
        <Route path="/social" element={<Social />} />
        <Route path="/smm" element={<Smm />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
